export default __webpack_public_path__ + "3b456ef383dc29e7ed46ce7654579181.png";